(function () {
  var MARKER = /\s*\[AI\]\s*/i;
  var BADGE_LABEL = (window.mbrAiBadgeSettings && window.mbrAiBadgeSettings.text) || 'AI GENERATED';
  var ALT_SUFFIX = ' (AI-generated image)';
  var processed = new WeakSet();

  function findBadgeHost(img) {
    var node = img.parentElement;

    while (node && node !== document.body) {
      if (node.classList.contains('media')) return node;

      var position = getComputedStyle(node).position;
      if (position === 'relative' || position === 'absolute' || position === 'sticky' || position === 'fixed') {
        return node;
      }

      node = node.parentElement;
    }

    return null;
  }

  function createBadgeHost(img) {
    // No positioned/.media ancestor exists (e.g. a plain <img> in a rich-text
    // block) — wrap the img in a new positioned span so a badge can always be
    // shown. insertBefore + appendChild(img) preserves the img's exact
    // original position in the DOM.
    var wrapper = document.createElement('span');
    wrapper.className = 'mbr-ai-badge-host';
    wrapper.style.position = 'relative';
    wrapper.style.display = 'inline-block';
    img.parentNode.insertBefore(wrapper, img);
    wrapper.appendChild(img);
    return wrapper;
  }

  function applyBadge(img) {
    if (processed.has(img) || !img.getAttribute) return;

    var alt = img.getAttribute('alt') || '';
    if (!MARKER.test(alt)) return;

    var host = findBadgeHost(img) || createBadgeHost(img);

    processed.add(img);
    img.setAttribute('alt', alt.replace(MARKER, '').trim() + ALT_SUFFIX);

    if (host.querySelector(':scope > .mbr-ai-badge')) return;

    var badge = document.createElement('span');
    badge.className = 'mbr-ai-badge';
    badge.setAttribute('aria-hidden', 'true');
    badge.textContent = BADGE_LABEL;
    host.appendChild(badge);
  }

  function scan(root) {
    root.querySelectorAll('img[alt*="[AI]" i]').forEach(applyBadge);
  }

  function init() {
    scan(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches('img')) applyBadge(node);
          if (node.querySelectorAll) scan(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
